import React, { useState, useEffect } from 'react';
import '../styling/forms.css';

const SchedulingForm = ({ category, onSubmit }) => {
  const [form, setForm] = useState({
    schedulingCategory: category,
    dateOfIssue: new Date().toISOString().split('T')[0],
    involvedTeam: '',
    errorType: '',
    description: '',
    impact: 'No Impact',
    correction: '',
    recurrenceRisk: 'Low'
  });

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const update = (e) => { const { name, value } = e.target; setForm((s) => ({ ...s, [name]: value })); };
  const submit = (e) => { e.preventDefault(); onSubmit(form); };

  return (
    <div className="form-wrapper">
      <h1>{category}</h1>
      <form className="card-form" onSubmit={submit}>
        <label>
          Date of Issue
          <input type="date" name="dateOfIssue" value={form.dateOfIssue} onChange={update} required />
        </label>
        <label>
          Team/Department
          <input name="involvedTeam" value={form.involvedTeam} onChange={update} />
        </label>
        <label>
          Error Type
          <select name="errorType" value={form.errorType} onChange={update}>
            <option value="">Select</option>
            <option>Appointment</option>
            <option>Communication</option>
            <option>Documentation</option>
            <option>System/Process</option>
          </select>
        </label>
        <label>
          Impact
          <select name="impact" value={form.impact} onChange={update}>
            <option>No Impact</option>
            <option>Delay</option>
            <option>Reschedule</option>
            <option>Cancellation</option>
          </select>
        </label>
        <label>
          Description
          <textarea name="description" rows="6" value={form.description} onChange={update} required />
        </label>
        <label>
          Correction/Prevention
          <textarea name="correction" rows="4" value={form.correction} onChange={update} />
        </label>
        <label>
          Recurrence Risk
          <select name="recurrenceRisk" value={form.recurrenceRisk} onChange={update}>
            <option>Low</option>
            <option>Moderate</option>
            <option>High</option>
          </select>
        </label>
        <div className="actions">
          <button type="submit" className="primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default SchedulingForm;


